import { render, staticRenderFns } from "./destroyDialog.vue?vue&type=template&id=4f823712"
import script from "./destroyDialog.vue?vue&type=script&lang=js"
export * from "./destroyDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports